import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "Does Glamur Paint protect walls too?",
    answer:
      "Yep! Our advanced formula resists stains, peeling, and fading so your walls stay fresh and fab for years, no matter what life throws at them.",
  },
  {
    question: "What kind of finishes do you offer?",
    answer:
      "From ultra-matte to high-gloss, we’ve got a finish for every vibe. Whether you want a cozy, soft look or a sleek, modern shine — Glamur’s got you covered.",
  },
];

const rightColumn = [
  {
    question: "Is Glamur Paint easy to apply?",
    answer:
      "Totally. It’s designed for smooth application with no streaks or patchiness. Even if you’re not a pro, your walls will still look like they were done by one.",
  },
  {
    question: "What is Glamur Paint all about?",
    answer:
      "Glamur Paint is where style meets strength — premium-quality paint made to give your walls that luxurious, smooth, and long-lasting glow. Basically, beauty that lasts.",
  },
  {
    question: "Can I use Glamur Paint for both home and office spaces?",
    answer:
      "100%. Glamur Paint fits any space — from your cozy bedroom to a high-end office — bringing elegance, depth, and durability wherever it goes.",
  },
];

const FAQoverview = () => {
  // ✅ Open the first question by default
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Ask Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQoverview;
